import React, { useState } from 'react';
import OrcamentoList from './OrcamentoList';
import EnderecoEntregaList from './EnderecoEntregaList';
import AnexosOrcamentoList from './AnexosOrcamentoList';
import OrcamentosTab from './orcamentos/OrcamentosTab';

interface OrcamentoTabsProps {
    opportunityId: number;
    etapaAtual: number;
    funilAtual: number;
    formatCurrency: (value: number | string) => string;
    onUpdateComplete: () => void;
}

const OrcamentoTabs: React.FC<OrcamentoTabsProps> = ({
    opportunityId,
    etapaAtual,
    funilAtual,
    formatCurrency,
    onUpdateComplete
}) => {
    const [activeTab, setActiveTab] = useState('orcamento');

    return (
        <div className="card">
            <div className="card-header pb-0">
                <ul className="nav nav-tabs nav-tabs-bordered">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'orcamento' ? 'active' : ''}`}
                            onClick={() => setActiveTab('orcamento')}
                        >
                            <i className="ti ti-calculator me-1"></i>
                            Itens do Orçamento
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'detalhes_orcamentos' ? 'active' : ''}`}
                            onClick={() => setActiveTab('detalhes_orcamentos')}
                        >
                            <i className="ti ti-files me-1"></i>
                            Detalhes dos Orçamentos
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'anexos_orcamento' ? 'active' : ''}`}
                            onClick={() => setActiveTab('anexos_orcamento')}
                        >
                            <i className="ti ti-file-invoice me-1"></i>
                            Anexos de Orçamento
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'enderecos' ? 'active' : ''}`}
                            onClick={() => setActiveTab('enderecos')}
                        >
                            <i className="ti ti-map-pin me-1"></i>
                            Endereços de Entrega
                        </button>
                    </li>
                </ul>
            </div>
            <div className="card-body">
                <div className="tab-content">
                    <div className={`tab-pane fade ${activeTab === 'orcamento' ? 'show active' : ''}`}>
                        <OrcamentoList
                            opportunityId={opportunityId}
                            etapaAtual={etapaAtual}
                            funilAtual={funilAtual}
                            formatCurrency={formatCurrency}
                            onUpdateComplete={onUpdateComplete}
                        />
                    </div>
                    <div className={`tab-pane fade ${activeTab === 'detalhes_orcamentos' ? 'show active' : ''}`}>
                        <OrcamentosTab
                            opportunityId={opportunityId}
                            etapaAtual={etapaAtual}
                            funilAtual={funilAtual}
                            formatCurrency={formatCurrency}
                            onUpdateComplete={onUpdateComplete}
                        />
                    </div>
                    <div className={`tab-pane fade ${activeTab === 'anexos_orcamento' ? 'show active' : ''}`}>
                        <AnexosOrcamentoList opportunityId={opportunityId} />
                    </div>
                    <div className={`tab-pane fade ${activeTab === 'enderecos' ? 'show active' : ''}`}>
                        <EnderecoEntregaList opportunityId={opportunityId} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrcamentoTabs;